import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { saveInitiateIv } from '../../procedures/initiateIv/store/initiateIv.actions'
import { QuickActionsConstants } from '../store/quickActions.constants'

export function* setInitiateIvQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addInitiateIVToTimeline } = quickActionsObject
  if (addInitiateIVToTimeline) {
    yield put(saveInitiateIv())
  }
}

export function* setInitiateIvQuickActionTimeLineRowSaga() {
  yield takeLatest([QuickActionsConstants.SET_ADD_INITIATE_IV_TO_TIMELINE], setInitiateIvQuickActionTimeLineRow)
}
